import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a29ac91"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel",
  style: {"gap":"8px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Consultant email", -1))
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Temp password", -1))
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Language", -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "save-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IciButton = _resolveComponent("IciButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InputText, {
        type: "email",
        modelValue: _ctx.consultant.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.consultant.email) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_InputText, {
        type: "password",
        modelValue: _ctx.consultant.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.consultant.password) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.consultant.language,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.consultant.language) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_IciButton, {
        class: "save-button",
        id: "submit",
        content: "Save",
        onButtonClick: _ctx.save,
        disabled: !_ctx.isFormValid,
        btnStyle: "width: 140px;",
        dark: true
      }, null, 8, ["onButtonClick", "disabled"])
    ])
  ]))
}